import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { TranslateModule } from '@ngx-translate/core';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { firstErrorMessage } from '../../forms/formly-errors';
import { FieldShellComponent } from '../../forms/field-shell.component';

@Component({
  selector: 'app-formly-mat-datepicker',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    TranslateModule,
    FormlyModule,
    FieldShellComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <app-field-shell
      [label]="props.label || ''"
      [for]="id"
      [required]="!!props.required"
      [hint]="props['hint'] || ('DD-MM-YYYY' | translate)"
      [errorMessage]="isInvalid() ? errorMessage() : ''">
      <mat-form-field
        appearance="outline"
        class="mty-flat w-full"
        [class.opacity-75]="formControl.disabled"
        [attr.data-field-id]="field.id">
        <input
          matInput
          [matDatepicker]="picker"
          [min]="props['minDate']"
          [max]="props['maxDate']"
          [id]="id"
          [formControl]="formControl"
          [formlyAttributes]="field"
          [required]="!!props.required"
          [placeholder]="'DD-MM-YYYY' | translate" />
        <mat-datepicker-toggle matIconSuffix [for]="picker" />
        <mat-datepicker #picker />
      </mat-form-field>
    </app-field-shell>
  `,
})
export class MatDatepickerFieldComponent extends FieldType<FieldTypeConfig> {
  isInvalid(): boolean {
    return this.formControl.invalid && (this.formControl.dirty || this.formControl.touched);
  }

  errorMessage(): string {
    return firstErrorMessage(this.formControl);
  }
}
